import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AppContext';

const BILLING_PATH = '/billing';

const RequireSubscription = ({ children }) => {
  const { subscriptionGate, subscriptionGateLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isBlocked = subscriptionGate?.isBlocked;
  const canAccessBillingOnly = subscriptionGate?.billingOnly;
  const isOnBillingPage = location.pathname === BILLING_PATH;
  const checkedRoleId = subscriptionGate?.checkedRoleId ?? null;
  const isInitialSubscriptionCheck = subscriptionGateLoading && checkedRoleId === null;
  const isRefreshingSubscriptionCheck = subscriptionGateLoading && checkedRoleId !== null;

  useEffect(() => {
    if (!subscriptionGateLoading && isBlocked && canAccessBillingOnly && !isOnBillingPage) {
      navigate(BILLING_PATH, {
        replace: true,
        state: { subscriptionGateBlocked: true },
      });
    }
  }, [canAccessBillingOnly, isBlocked, isOnBillingPage, navigate, subscriptionGateLoading]);

  if (isInitialSubscriptionCheck) {
    return <div>Loading...</div>;
  }

  if (isBlocked && canAccessBillingOnly && !isOnBillingPage) {
    return (
      <Navigate
        to={BILLING_PATH}
        replace
        state={{ subscriptionGateBlocked: true }}
      />
    );
  }

  return (
    <>
      {isRefreshingSubscriptionCheck && (
        <div className="pointer-events-none fixed right-4 top-4 z-[55] rounded-xl border border-[#dbe2ff] bg-white/95 px-3 py-2 text-xs text-[#4b5565] shadow-[0_12px_28px_rgba(15,23,42,0.12)] backdrop-blur-sm">
          <div className="flex items-center gap-2">
            <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-[#c7d2fe] border-t-[#4a63ff]" />
            <span>Checking subscription...</span>
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default RequireSubscription;
